"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLayoutToken = exports.LayoutConfig = void 0;
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var Layout_1 = require("@CommonFrontend/Public/Widgets/Layout/Layout");
var lodash_1 = require("lodash");
var styles = __importStar(require("../../Public/Widgets/Layout/Layout.css"));
var SideBySide_1 = require("@CommonFrontend/ContentTokens/Models/SideBySide");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var zod_1 = require("zod");
var upgradableTokenSchema = zod_1.z.object({
    type: zod_1.z.enum(["block", "inline"]),
    subType: zod_1.z.literal("sideBySide"),
    percent: zod_1.z.number(),
    order: zod_1.z.enum(["normal", "reverse"]).optional().nullable(),
    column1: zod_1.z.array(zod_1.z.unknown()),
    column2: zod_1.z.array(zod_1.z.unknown()),
    width: zod_1.z.enum(["content", "wide", "full", "normal"]).optional().nullable(),
});
exports.LayoutConfig = {
    type: "layout",
    tokenType: {},
    publicRenderHtmlString: function (props) { return server_1.default.renderToString(react_1.default.createElement(Layout_1.Layout, {
        attributes: props.attributes,
        columns: props.token.columns.map(function (column) { return ({ content: props.renderTokens(column.content), width: column.width }); }),
        gap: props.token.gap,
        padding: props.token.padding,
        alignment: props.token.alignment
    })); },
    flattenForComments: function (currentToken, flattenedTokens) {
        (0, lodash_1.flattenDeep)(currentToken.columns.map(function (column) { return column.content; })).forEach(function (t) { return flattenedTokens.push(t); });
    },
    tokenTraversers: {
        getFlatFromListOfTokens: function (token, runFlat) {
            var _a, _b, column, _c, _d, columnToken, e_1_1, e_2_1;
            var e_2, _e, e_1, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4, token];
                    case 1:
                        _g.sent();
                        _g.label = 2;
                    case 2:
                        _g.trys.push([2, 13, 14, 15]);
                        _a = __values(token.columns), _b = _a.next();
                        _g.label = 3;
                    case 3:
                        if (!!_b.done) return [3, 12];
                        column = _b.value;
                        _g.label = 4;
                    case 4:
                        _g.trys.push([4, 9, 10, 11]);
                        _c = (e_1 = void 0, __values(runFlat(column.content))), _d = _c.next();
                        _g.label = 5;
                    case 5:
                        if (!!_d.done) return [3, 8];
                        columnToken = _d.value;
                        return [4, columnToken];
                    case 6:
                        _g.sent();
                        _g.label = 7;
                    case 7:
                        _d = _c.next();
                        return [3, 5];
                    case 8: return [3, 11];
                    case 9:
                        e_1_1 = _g.sent();
                        e_1 = { error: e_1_1 };
                        return [3, 11];
                    case 10:
                        try {
                            if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7];
                    case 11:
                        _b = _a.next();
                        return [3, 3];
                    case 12: return [3, 15];
                    case 13:
                        e_2_1 = _g.sent();
                        e_2 = { error: e_2_1 };
                        return [3, 15];
                    case 14:
                        try {
                            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7];
                    case 15: return [2];
                }
            });
        },
        getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
            var e_3, _a;
            try {
                for (var _b = __values(token.columns), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var column = _c.value;
                    column.content = unpackAndTransformFn(column.content);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
        },
    },
    tokenUpgradeConverter: function (token, _a) {
        var _b, _c;
        var usingFeature = _a.usingFeature, logError = _a.logError;
        if (!usingFeature(FeatureFlag_1.default.ReplaceSideBySideWithLayout))
            return;
        if (token.subType !== "sideBySide") {
            return;
        }
        var parsed = upgradableTokenSchema.safeParse(token);
        if (!parsed.success) {
            logError(JSON.stringify(parsed.error.issues));
            return;
        }
        ;
        var parsedToken = parsed.data;
        var percent = (_b = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.percent) !== null && _b !== void 0 ? _b : 50;
        var firstColSize = Math.round(24 * (percent / 100));
        var isNormalOrder = ((_c = parsedToken.order) !== null && _c !== void 0 ? _c : SideBySide_1.SideBySideOrder.Normal) === SideBySide_1.SideBySideOrder.Normal;
        return __assign(__assign({}, (0, exports.createLayoutToken)()), { gap: 30, columns: [
                { content: isNormalOrder ? parsedToken.column1 : parsedToken.column2, width: firstColSize },
                { content: isNormalOrder ? parsedToken.column2 : parsedToken.column1, width: 24 - firstColSize },
            ], width: ((parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.width) === "normal") ? "wide" : (parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.width) || "wide" });
    },
    traits: {
        resizeable: {
            width: {
                wide: true,
                custom: false,
                default: "content",
                fullBleedOnMobile: false,
            },
            handleDirections: "corners",
        },
        spacingShim: {
            className: styles.spacingShim,
        },
        skipContainerAnimation: {},
        selection: {
            ringMode: "outside",
            dragHandleTop: "selection-ring",
            showWidgetOutlineOnHover: true
        }
    },
};
var createLayoutToken = function () {
    return {
        type: "block",
        subType: "layout",
        columns: [
            { content: [], width: 12 },
            { content: [], width: 12 },
        ],
        gap: 12,
        padding: 0,
        alignment: "start",
    };
};
exports.createLayoutToken = createLayoutToken;
